import { WWT_TAG, wwtLogWithoutTag } from '@wwt/core/admin'

const MODAL_MANAGER_LOG = [
	WWT_TAG[0] + '%c[MODAL_MANAGER]',
	WWT_TAG[1],
	'color: #22c55e; font-weight: bold;'
]

// TODO: Change to normal logger system
export const wwtModalManagerLog = (...messages: unknown[]) => {
	wwtLogWithoutTag(...MODAL_MANAGER_LOG, ...messages)
}
